import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { InputText } from 'primeng/inputtext';
import { InputNumber } from 'primeng/inputnumber';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogModule, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-add-table',
  templateUrl: './add-table.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [InputText, InputNumber, ButtonModule, ReactiveFormsModule, TranslateModule, DynamicDialogModule],
})
export class AddTableComponent implements OnInit {
  public formAddTable: FormGroup;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private fb: FormBuilder,
    public translate: TranslateService
  ) {
    this.formAddTable = this.fb.group({
      name: ['', [Validators.required]],
      capacity: [1, [Validators.required]],
      min_limit: [1, [Validators.required]],
    }, { validators: this.postiSuperioriCapacitaValidator() });
  }

  ngOnInit(): void {
    // If we have data, we're in edit mode
    if (this.config.data) {
      this.formAddTable.patchValue({
        name: this.config.data.name,
        capacity: this.config.data.capacity,
        min_limit: this.config.data.min_limit,
      });
    }
  }

  postiSuperioriCapacitaValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const posti = control.get('min_limit');
      const capacita = control.get('capacity');

      if (posti && capacita && posti.value > capacita.value) {
        return { 'postiSuperioriCapacita': true };
      }
      return null;
    };
  }

  Close() {
    if (this.formAddTable.valid) {
      const tableData = this.formAddTable.value;
      tableData.id_table = this.config.data?.id_table;
      tableData.fk_status = this.config.data?.fk_status;
      this.ref.close(tableData);
    }
  }
}
